import { isNil } from 'lodash-es'
import { default as React, FunctionComponent } from 'react'

import { tDefaults } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'

export const InputLoopFormatter: FunctionComponent<Formatter<unknown[]>> = ({
  value,
  t,
}) => {
  return <>{isNil(value) ? t(tDefaults('inputs.no-answer')) : value.length}</>
}
